module.exports = __webpack_public_path__ + "static/media/clock2.0435eb96.svg";